import { styled } from "goober";

export const ScrollContainer = styled("div")`
  overflow: auto;
  width: 100%;
  height: 100%;
`;

export const Table = styled("table")`
  min-width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled("thead")`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const Th = styled("th")`
  background: var(--surface-secondary);
  box-shadow: inset 0 -0.5px 0 var(--border-alpha);
  border-right: 0.5px solid var(--border-alpha);
  padding: 0 16px 2px;
  height: 36px;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-right: none;
  }
`;

export const Td = styled("td")`
  border-bottom: 0.5px solid var(--border-alpha);
  border-right: 0.5px solid var(--border-alpha);
  padding: 0 16px 2px;
  height: 36px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-right: none;
  }
`;
